const ERROR = '_ERROR';
const SUCCESS = '_SUCCESS';

// Auth Action Types
export const LOGIN_INFO_REQUEST = 'LOGIN_INFO_REQUEST';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';
export const SWITCH_IMPL_REQUEST = 'SWITCH_IMPL_REQUEST';
export const SWITCH_IMPL_SUCCESS = 'SWITCH_IMPL_SUCCESS';
export const SWITCH_IMPL_ERROR = 'SWITCH_IMPL_ERROR';
export const GET_USER_DATA_REQUEST = 'GET_USER_DATA_REQUEST';
export const GET_LOGIN_INFO_SUCCESS = 'GET_LOGIN_INFO_SUCCESS';
const GET_LOGIN_INFO_ERROR = 'GET_LOGIN_INFO_ERROR';
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const GET_USER_DATA_ERROR = 'GET_USER_DATA_ERROR';
export const UPDATE_USER_DATA_SUCCESS = 'UPDATE_USER_DATA_SUCCESS';
export const GET_CFM_AUTOLOGIN_REQUEST = 'GET_CFM_AUTOLOGIN_REQUEST';
export const GET_CFM_AUTOLOGIN_SUCCESS = 'GET_CFM_AUTOLOGIN_SUCCESS';
export const GET_CFM_AUTOLOGIN_ERROR = 'GET_CFM_AUTOLOGIN_ERROR';
export const OPEN_2FA = 'OPEN_2FA';
export const CLOSE_2FA = 'CLOSE_2FA';
export const LOGIN_2FA_SUCCESS = 'LOGIN_2FA_SUCCESS';
export const LOGIN_OAUTH_REQUEST = 'LOGIN_OAUTH_REQUEST';
export const LOGIN_OAUTH_SUCCESS = 'LOGIN_OAUTH_SUCCESS';
export const RESET_USER_LOGIN_INFO = 'RESET_USER_LOGIN_INFO';
export const SET_SCOPED_TOKEN = 'SET_SCOPED_TOKEN';

// Domain Action Types
export const GET_NAVBAR_OPTIONS = 'GET_NAVBAR_OPTIONS';
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';
export const SET_WITH_TABS = 'SET_WITH_TABS';
export const CLEAR_ALL = 'CLEAR_ALL';

// Filters
export const FILTERS_CHANGE = 'FILTERS_CHANGE';
export const FILTERS_TOGGLE = 'FILTERS_TOGGLE';

// Implementation Action Types
export const GET_IMPLEMENTATIONS_REQUEST = 'GET_IMPLEMENTATIONS_REQUEST';
export const GET_IMPLEMENTATIONS_SUCCESS = 'GET_IMPLEMENTATIONS_SUCCESS';
export const GET_IMPLEMENTATIONS_ERROR = 'GET_IMPLEMENTATIONS_ERROR';
export const GET_IMPLEMENTATION_DETAIL_REQUEST = 'GET_IMPLEMENTATION_DETAIL_REQUEST';
export const GET_IMPLEMENTATION_DETAIL_SUCCESS = 'GET_IMPLEMENTATION_DETAIL_SUCCESS';
export const GET_IMPLEMENTATION_DETAIL_ERROR = 'GET_IMPLEMENTATION_DETAIL_ERROR';
export const CREATE_FAVORITE_SUCCESS = 'CREATE_FAVORITE_SUCCESS';
export const CREATE_FAVORITE_ERROR = 'CREATE_FAVORITE_ERROR';
export const REMOVE_FAVORITE_SUCCESS = 'REMOVE_FAVORITE_SUCCESS';
export const REMOVE_FAVORITE_ERROR = 'REMOVE_FAVORITE_ERROR';
export const GET_FAVORITES_REQUEST = 'GET_FAVORITES_REQUEST';
export const GET_FAVORITES_SUCCESS = 'GET_FAVORITES_SUCCESS';
export const GET_FAVORITES_ERROR = 'GET_FAVORITES_ERROR';
export const GET_LICENSES_REQUEST = 'GET_LICENSES_REQUEST';
export const GET_LICENSES_SUCCESS = 'GET_LICENSES_SUCCESS';
export const GET_LICENSES_ERROR = 'GET_LICENSES_ERROR';
export const SET_IMPLEMENTATION_DETAIL_PARAMETER = 'SET_IMPLEMENTATION_DETAIL_PARAMETER';
export const SET_IMPLEMENTATION_DETAIL_TRAITS = 'SET_IMPLEMENTATION_DETAIL_TRAITS';

// Literals
export const GET_LITERALS_REQUEST = 'GET_LITERALS_REQUEST';
export const GET_LITERALS_SUCCESS = 'GET_LITERALS_SUCCESS';
export const GET_LITERALS_ERROR = 'GET_LITERALS_ERROR';

// Implementation literals
const GET_IMPLEMENTATION_LITERALS_REQUEST = 'GET_IMPLEMENTATION_LITERALS_REQUEST';
const GET_IMPLEMENTATION_LITERALS_SUCCESS = 'GET_IMPLEMENTATION_LITERALS_SUCCESS';
const GET_IMPLEMENTATION_LITERALS_ERROR = 'GET_IMPLEMENTATION_LITERALS_ERROR';
const INPUT_PROPOSAL_CHANGE = 'INPUT_PROPOSAL_CHANGE';
const ISUPDATE_CHANGE = 'ISUPDATE_CHANGE';
const RESTART_PROPOSAL_CHANGE = 'RESTART_PROPOSAL_CHANGE';
const LITERALS_CHANGE_ACTIVE_SECTION = 'LITERALS_CHANGE_ACTIVE_SECTION';

// Permissions
export const GET_PERMISSIONS_REQUEST = 'GET_PERMISSIONS_REQUEST';
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS';
export const GET_PERMISSIONS_ERROR = 'GET_PERMISSIONS_ERROR';

// Sandbox
export const GET_SANDBOX_STATE_REQUEST = 'GET_SANDBOX_STATE_REQUEST';
export const GET_SANDBOX_STATE_SUCCESS = 'GET_SANDBOX_STATE_SUCCESS';
export const GET_SANDBOX_STATE_ERROR = 'GET_SANDBOX_STATE_ERROR';
export const CREATE_SANDBOX_REQUEST = 'CREATE_SANDBOX_REQUEST';
export const CREATE_SANDBOX_SUCCESS = 'CREATE_SANDBOX_SUCCESS';
export const CREATE_SANDBOX_ERROR = 'CREATE_SANDBOX_ERROR';
export const GET_SANDBOX_REQUEST = 'GET_SANDBOX_REQUEST';
export const GET_SANDBOX_SUCCESS = 'GET_SANDBOX_SUCCESS';
export const GET_SANDBOX_ERROR = 'GET_SANDBOX_ERROR';

// Users
export const CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER';
export const GET_IMPL_SUMMARY_REQUEST = 'GET_IMPL_SUMMARY_REQUEST';
export const GET_IMPL_SUMMARY_SUCCESS = 'GET_IMPL_SUMMARY_SUCCESS';
export const GET_IMPL_SUMMARY_ERROR = 'GET_IMPL_SUMMARY_ERROR';
export const GET_SSO_PROVIER_REQUEST = 'GET_SSO_PROVIER_REQUEST';
export const GET_SSO_PROVIER_SUCCESS = 'GET_SSO_PROVIER_SUCCESS';
export const GET_SSO_PROVIER_ERROR = 'GET_SSO_PROVIER_ERROR';
export const GET_USERS_HIERACHY_REQUEST = 'GET_USERS_HIERACHY_REQUEST';
export const GET_USERS_HIERACHY_SUCCESS = 'GET_USERS_HIERACHY_SUCCESS';
export const GET_USERS_HIERACHY_ERROR = 'GET_USERS_HIERACHY_ERROR';
export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_ERROR = 'GET_USER_ERROR';
export const GET_USER_SCHEMA_REQUEST = 'GET_USER_SCHEMA_REQUEST';
export const GET_USER_SCHEMA_SUCCESS = 'GET_USER_SCHEMA_SUCCESS';
export const GET_USER_SCHEMA_ERROR = 'GET_USER_SCHEMA_ERROR';
export const GET_USER_COUNTRY_CODES_REQUEST = 'GET_USER_COUNTRY_CODES_REQUEST';
export const GET_USER_COUNTRY_CODES_SUCCESS = 'GET_USER_COUNTRY_CODES_SUCCESS';
export const GET_USER_COUNTRY_CODES_ERROR = 'GET_USER_COUNTRY_CODES_ERROR';

// Api keys
export const CLEAR_CRUD_APIKEY = 'CLEAR_CRUD_APIKEY';
export const GET_APIKEYS_REQUEST = 'GET_APIKEYS_REQUEST';
export const GET_APIKEYS_SUCCESS = 'GET_APIKEYS_SUCCESS';
export const GET_APIKEYS_ERROR = 'GET_APIKEYS_ERROR';
export const GET_APIKEY_REQUEST = 'GET_APIKEY_REQUEST';
export const GET_APIKEY_SUCCESS = 'GET_APIKEY_SUCCESS';
export const GET_APIKEY_ERROR = 'GET_APIKEY_ERROR';
export const GET_APIKEYS_FTP_REQUEST = 'GET_APIKEYS_FTP_REQUEST';
export const GET_APIKEYS_FTP_SUCCESS = 'GET_APIKEYS_FTP_SUCCESS';
export const GET_APIKEYS_FTP_ERROR = 'GET_APIKEYS_FTP_ERROR';
export const GET_APIKEYS_MAPS_REQUEST = 'GET_APIKEYS_MAPS_REQUEST';
export const GET_APIKEYS_MAPS_SUCCESS = 'GET_APIKEYS_MAPS_SUCCESS';
export const GET_APIKEYS_MAPS_ERROR = 'GET_APIKEYS_MAPS_ERROR';
export const GET_APIKEYS_USAGE_PLANS_REQUEST = 'GET_APIKEYS_USAGE_PLANS_REQUEST';
export const GET_APIKEYS_USAGE_PLANS_SUCCESS = 'GET_APIKEYS_USAGE_PLANS_SUCCESS';
export const GET_APIKEYS_USAGE_PLANS_ERROR = 'GET_APIKEYS_USAGE_PLANS_ERROR';
export const GET_APIKEYS_EXTERNAL_PROVIDERS_REQUEST = 'GET_APIKEYS_EXTERNAL_PROVIDERS_REQUEST';
export const GET_APIKEYS_EXTERNAL_PROVIDERS_SUCCESS = 'GET_APIKEYS_EXTERNAL_PROVIDERS_SUCCESS';
export const GET_APIKEYS_EXTERNAL_PROVIDERS_ERROR = 'GET_APIKEYS_EXTERNAL_PROVIDERS_ERROR';
export const DELETE_APIKEY_SUCCESS = 'DELETE_APIKEY_SUCCESS';
export const DELETE_FTPUSER_SUCCESS = 'DELETE_FTPUSER_SUCCESS';
export const SET_APIKEYS_ACTIVE_TAB = 'SET_APIKEYS_ACTIVE_TAB';

// Server List
export const LOAD_SERVER_LIST = 'LOAD_SERVER_LIST';
export const LOAD_SERVER_LIST_SUCCESS = 'LOAD_SERVER_LIST_SUCCESS';
export const LOAD_SERVER_LIST_ERROR = 'LOAD_SERVER_LIST_ERROR';
export const CLEAR_SERVER_LIST = 'CLEAR_SERVER_LIST';

// Fuzzy
export const FUZZY_REQUEST = 'FUZZY_REQUEST';
export const FUZZY_SUCCESS = 'FUZZY_SUCCESS';
export const FUZZY_ERROR = 'FUZZY_ERROR';
export const FUZZY_CLEAR = 'FUZZY_CLEAR';

// Roles
export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_ERROR = 'GET_ROLES_ERROR';

// Device Cache
export const GET_DEVICE_CACHE_REQUEST = 'GET_DEVICE_CACHE_REQUEST';
export const GET_DEVICE_CACHE_SUCCESS = 'GET_DEVICE_CACHE_SUCCESS';
export const GET_DEVICE_CACHE_ERROR = 'GET_DEVICE_CACHE_ERROR';
export const SET_DEVICE_CACHE_REQUEST = 'SET_DEVICE_CACHE_REQUEST';
export const SET_DEVICE_CACHE_SUCCESS = 'SET_DEVICE_CACHE_SUCCESS';
export const SET_DEVICE_CACHE_ERROR = 'SET_DEVICE_CACHE_ERROR';
